module.exports = __webpack_public_path__ + "img/Picture13.73947427.png";